import TableComponent from "../../components/organism/Table/TableComponent";
import { FC, useMemo } from "react";
import { Center } from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";
import { CellProps, Column } from "react-table";
import { useNavigate } from "react-router-dom";
import { primaryColor } from "../../utils/colors";
import { AuthUser } from "../../types/User/AuthUser";

interface TableOrganizationProps {
  setIdUpdateItem: (id: number) => void;
  dataTable: any[];
  isLoaded: boolean;
  setValue: (key: string, value: any) => void;
  user: AuthUser;
}

const TableOrganization: FC<TableOrganizationProps> = ({
  setIdUpdateItem,
  dataTable,
  isLoaded,
  setValue,
  user,
}) => {
  const navigate = useNavigate();

  const columns = useMemo(() => {
    const baseColumns: Column[] = [
      { Header: "Nome", accessor: "name" },
      { Header: "Tipo de entidade", accessor: "organizationLevel.name" },
      { Header: "Email", accessor: "email" },
    ];
    if (user?.permissions && user.permissions.includes("EditOrganizations")) {
      baseColumns.push({
        Header: "Gerir",
        accessor: "edit",
        disableSortBy: true,
        Cell: ({ row }: CellProps<any, string>) => (
          <Center justifyContent="flex-end">
            <EditIcon
              color={primaryColor}
              boxSize={6}
              mr="10px"
              cursor="pointer"
              onClick={() => {
                navigate(`/entidades/${row.original.id}`, {
                  state: { organization: row.original },
                });
              }}
            />
          </Center>
        ),
      });
    }

    return baseColumns;
  }, [user.permissions, navigate]);

  return (
    <TableComponent
      isLoaded={isLoaded}
      columns={columns}
      data={dataTable}
      fixedColumnIds={[{ value: "edit", hasShadow: true }]}
    />
  );
};

export default TableOrganization;
